export const blockIconsTextformattingDrawNew = (
	<span className='material-symbols-outlined'>draw</span>
);
